<div class="h-full w-full flex flex-col justify-between p-input-filled" id="topLevel">
  <p-blockui [blocked]="parent?.isBusy()">
    <div class="progress-spinner">
      <p-progressSpinner></p-progressSpinner>
    </div>
  </p-blockui>
  <div class="help-button-container">
    <button *ngIf="hasHelp" pButton type="button" (click)="showHelp()" class="p-button-rounded p-button-text"
      icon="pi pi-question-circle" title="Help"></button>
  </div>
  <div *ngIf="!parent?.isPageReady" class="loading-center">
    <p-progressSpinner ariaLabel="center" />
  </div>
  <div *ngIf="parent?.isPageReady" class="flex flex-col grow min-h-0">
    <fieldset class="flex flex-col grow min-h-0 overflow-visible fieldset-no-border" [disabled]="isDisabled">
      <ng-container *ngTemplateOutlet="bodyTemplate ? bodyTemplate : defaultBody"></ng-container>
    </fieldset>
    <div class="flex-shrink-0">
      <ng-container *ngTemplateOutlet="footerTemplate ? footerTemplate : defaultFooter"></ng-container>
    </div>
  </div>
</div>
<!-- Centralized confirm dialogs - no need to add p-confirmDialog in individual components -->
<p-confirmDialog key="globalErrorDialog" styleClass="red-header"></p-confirmDialog>
<p-confirmDialog [closable]="false" [baseZIndex]="999"></p-confirmDialog>

<ng-template #defaultBody></ng-template>
<ng-template #defaultFooter>
  <div *ngIf="showBack || !hasMethod('hasChanges')" class="mt-3 ml-3">
    <button (click)="navigateBack()" pButton type="button" icon="pi pi-backward" label="Go Back"
      class="p-button-raised" title="Go Back"></button>
  </div>
</ng-template>
